import { DateTime } from 'luxon';
import { getApplicationDurationType } from '@gbr-monorepo/frontend';
import { UserApplication } from '@gbr-monorepo/interfaces';
import { AdminApplicationType } from '../../../shared/enums/application-type.enum';
import { PayoutPeriodLabel } from '@gbr-monorepo/interfaces';
import { PayoutPeriodOperations } from '../../operations/payout-period.operations';

export class SeasonStateOperations {
    public static getApplicationType(application: UserApplication): AdminApplicationType {
        return getApplicationDurationType(application.travelStartDate, application.travelEndDate) === 'LONG'
            ? AdminApplicationType.LONG
            : AdminApplicationType.SHORT;
    }

    public static getFiscalHalfYear(application: UserApplication): PayoutPeriodLabel {
        return PayoutPeriodOperations.getLabelFromDate(
            DateTime.fromISO(String(application.travelEndDate), { zone: 'utc' })
        );
    }
}
